import "./styles.scss";

import { useTranslation } from "react-i18next";

import { useReferralPrograms } from "context/referral-programs";

import DashboardContentLayout from "components/layouts/DashboardContentLayout";
import Button from "components/Button";
import useResponsive from "libs/helpers/useResponsive";

import { ReferralProgramsTable, ReferralProgramsTiles } from "./components";
import {
  hasPayableWallet,
  payoutFiles,
} from "./paypalPayoutCsv";

const actions = [
  {
    type: "send_notification",
  },
  {
    type: "create_task",
  },
];

const mainClass = "referral-admin-content";

const ReferralProgramsContent = () => {
  const { t } = useTranslation();
  const { max } = useResponsive();

  const { data, loading, init_loading } = useReferralPrograms();

  const exportPayouts = () => {
    payoutFiles(data).forEach(({ filename, content }, index) => {
      window.setTimeout(() => {
        const blob = new Blob([content], { type: "text/csv;charset=utf-8" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");

        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.setTimeout(() => URL.revokeObjectURL(url), 1000);
      }, index * 300);
    });
  };

  return (
    <DashboardContentLayout
      header={{
        label: t("Referral program"),
        description: t("All users registered in the system."),
        aside: (
          <Button
            size="small"
            disabled={!hasPayableWallet(data)}
            onClick={exportPayouts}
          >
            {t("Export")}
          </Button>
        ),
      }}
      loading={init_loading}
      actions={actions}
    >
      <div className={mainClass}>
        {!max.lg ? (
          <ReferralProgramsTable data={data} loading={!!loading} />
        ) : (
          <ReferralProgramsTiles data={data} loading={!!loading} />
        )}
      </div>
    </DashboardContentLayout>
  );
};

export default ReferralProgramsContent;
